const Call = ({ ...props }) => {
    return (
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.23743 2.70789L4.07736 1.28725L4.87721 1.02646C6.20667 0.592523 8.14203 5.01248 7.03581 6.0046L5.48926 7.35178C4.10358 8.59384 8.75268 15.2331 10.3937 14.356L12.1885 13.3634C13.4991 12.6632 16.9907 15.9935 16.1282 17.0945L15.6095 17.7569L13.6453 18.9999C6.56549 19.0065 -0.190232 9.35848 2.23743 2.70788L2.23743 2.70789Z"
                fill="white"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Call
